export default {"src":"/_next/static/media/tide-logo-blue-noreg.9f1e6992.svg","height":102,"width":245,"blurWidth":0,"blurHeight":0};